/*
 * Public API Surface of optix-lib
 */

export * from './lib/optix-lib.component';
export * from './lib/optix-lib.module';
